import { css } from "@linaria/core";

import { breakpoints, units } from "@ui/css";
import { typographies } from "@ui/kit/design-tokens";

export const articleCls = css`
  min-height: ${units.px(200)};
  word-break: break-word;
  font-size: ${typographies.body.fontSize()};

  @media ${breakpoints.mobile.toQuery()} {
    hyphens: auto;
  }

  /**
   * fix scroll snapping issue where footer cannot be accessed, when a
   * harmonica iframe component is positioned at the bottom of the screen
   */
  &
    > [data-content-component="true"]:last-child
    > [data-component-type="harmonica-iframe-component"]:only-child {
    margin-bottom: 140px;
  }
`;
